define('OutSystems/ClientRuntime/modules/Database/Metadata/EntityUpgradeStatus',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EntityUpgradeStatus;
    (function (EntityUpgradeStatus) {
        EntityUpgradeStatus[EntityUpgradeStatus["Unchanged"] = 0] = "Unchanged";
        EntityUpgradeStatus[EntityUpgradeStatus["Deleted"] = 1] = "Deleted";
        EntityUpgradeStatus[EntityUpgradeStatus["Recreated"] = 2] = "Recreated";
        EntityUpgradeStatus[EntityUpgradeStatus["New"] = 3] = "New";
    })(EntityUpgradeStatus || (EntityUpgradeStatus = {}));
    exports.default = EntityUpgradeStatus;
});
//# sourceMappingURL=EntityUpgradeStatus.js.map;
